export function listBefore<T>(list: T[], condition: (el: T) => boolean): T[] {
    const pos = list.findIndex(condition);
    if (pos === -1) {
        return [...list];
    } else {
        return list.slice(0, pos);
    }
}

export function listΑfter<T>(list: T[], condition: (el: T) => boolean): T[] {
    const pos = list.findIndex(condition);
    if (pos === -1) {
        return [];
    } else {
        return list.slice(pos);
    }
}

export function listBeforeAndΑfter<T>(list: T[], condition: (el: T) => boolean): T[][] {
    const pos = list.findIndex(condition);
    if (pos === -1) {
        return [[...list], []];
    } else {
        return [list.slice(0, pos), list.slice(pos)];
    }
}